import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { ActionLink } from '../components/ui/ActionLink';
export function NotFound() {
  usePageMeta('Page not found | ES World', 'This page does not exist. Go back to the ES World homepage or see all courses.');
  return <section className="w-full bg-cream" data-id="element-1250" data-mp="154xwa1y5xxeh">
      <div className="mx-auto max-w-content px-5 py-24 md:px-8 md:py-32" data-id="element-1251" data-mp="155qycpm6fyqa">
        <h1 className="type-h1 text-ink" data-id="element-1252" data-mp="1a4k9ibdzrdna">We cannot find this page</h1>
        <p className="mt-6 max-w-xl type-body" data-id="element-1253" data-mp="1a27tw4vphfde">The link may be old, or the page may have moved. You can go to the homepage or see all courses.</p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-1254" data-mp="1juwv86xjlcv0">
          <ActionLink to="/" data-id="element-1255" data-mp="1nv7c4emvhnon">Go to the homepage</ActionLink>
          <ActionLink to="/programmes" variant="secondary" data-id="element-1256" data-mp="1nunrur9r2n7g">
            See all courses
          </ActionLink>
        </div>
      </div>
    </section>;
}